import React from 'react'

const Tap = () => {
  return (
    <svg
      // width="99"
      // height="104"
      // width="45"
      // height="50"
      viewBox="0 0 99 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_170_96)">
        <g filter="url(#filter1_d_170_96)">
          <path
            d="M61.246 26.8385H55.7926C55.7926 23.2238 54.3562 19.7572 51.7995 17.2013C49.2427 14.6453 45.775 13.2094 42.1591 13.2094C38.5433 13.2094 35.0756 14.6453 32.5188 17.2013C29.962 19.7572 28.5257 23.2238 28.5257 26.8385H23.0723C23.0723 21.778 25.0832 16.9247 28.6627 13.3464C32.2422 9.76809 37.097 7.75781 42.1591 7.75781C47.2213 7.75781 52.0761 9.76809 55.6556 13.3464C59.2351 16.9247 61.246 21.778 61.246 26.8385Z"
            fill="black"
          />
        </g>
        <g filter="url(#filter2_d_170_96)">
          <path
            d="M74.8795 45.9202C73.4708 45.9252 72.0883 46.3013 70.8713 47.0105C70.1362 45.8449 69.1183 44.8839 67.9123 44.2167C66.7063 43.5496 65.3511 43.1979 63.9728 43.1944C62.5641 43.1994 61.1816 43.5755 59.9645 44.2847C58.9725 42.7242 57.4808 41.5459 55.7327 40.942C53.9847 40.338 52.0835 40.3441 50.3393 40.9592V26.8395C50.3393 24.6707 49.4775 22.5908 47.9434 21.0572C46.4093 19.5237 44.3287 18.6621 42.1592 18.6621C39.9897 18.6621 37.9091 19.5237 36.375 21.0572C34.841 22.5908 33.9791 24.6707 33.9791 26.8395V57.096L27.8986 52.9528C26.5047 51.915 24.8103 51.36 23.0723 51.3718C21.4499 51.3678 19.8629 51.8462 18.5132 52.7462C17.1634 53.6461 16.1118 54.927 15.4922 56.426C14.8725 57.925 14.7128 59.5743 15.0332 61.1643C15.3536 62.7542 16.1398 64.213 17.2918 65.3552L39.1053 85.2536C42.1936 88.0168 46.1947 89.541 50.3393 89.5331H63.9728C69.0349 89.5331 73.8897 87.5228 77.4692 83.9445C81.0487 80.3662 83.0596 75.5129 83.0596 70.4524V54.0976C83.0596 51.9288 82.1978 49.8488 80.6637 48.3153C79.1297 46.7817 77.049 45.9202 74.8795 45.9202V45.9202ZM77.6062 70.4524C77.6062 74.0671 76.1699 77.5337 73.6131 80.0896C71.0563 82.6455 67.5886 84.0815 63.9728 84.0815H50.3393C47.5832 84.1148 44.9088 83.1461 42.8136 81.3557L21.1364 61.4573C20.6327 60.9496 20.3487 60.2643 20.3457 59.5492C20.3457 59.043 20.4867 58.5468 20.7529 58.1162C21.0191 57.6855 21.4 57.3376 21.8529 57.1112C22.3059 56.8848 22.8129 56.7889 23.3172 56.8344C23.8216 56.8799 24.3033 57.0648 24.7084 57.3686L39.4325 67.454V26.8395C39.4325 26.1166 39.7198 25.4233 40.2311 24.9121C40.7425 24.4009 41.436 24.1137 42.1592 24.1137C42.8824 24.1137 43.5759 24.4009 44.0873 24.9121C44.5986 25.4233 44.8859 26.1166 44.8859 26.8395V56.8234H50.3393V48.646C50.3393 47.923 50.6266 47.2297 51.1379 46.7185C51.6493 46.2074 52.3428 45.9202 53.066 45.9202C53.7892 45.9202 54.4827 46.2074 54.9941 46.7185C55.5054 47.2297 55.7927 47.923 55.7927 48.646V56.8234H61.2461V51.3718C61.2461 50.6489 61.5333 49.9555 62.0447 49.4443C62.5561 48.9332 63.2496 48.646 63.9728 48.646C64.6959 48.646 65.3895 48.9332 65.9008 49.4443C66.4122 49.9555 66.6995 50.6489 66.6995 51.3718V56.8234H72.1529V54.0976C72.1529 53.3747 72.4401 52.6813 72.9515 52.1702C73.4628 51.659 74.1564 51.3718 74.8795 51.3718C75.6027 51.3718 76.2963 51.659 76.8076 52.1702C77.319 52.6813 77.6062 53.3747 77.6062 54.0976V70.4524Z"
            fill="black"
          />
        </g>
        <path
          d="M38.5933 22.6445V62.0639L21.8137 53.6768L16.7798 59.5478L47.8222 86.3865L69.6357 84.709L78.8645 77.1607C78.8645 69.0531 79.0323 52.6703 79.7035 51.9994C80.3747 51.3284 76.6272 49.4832 74.6696 48.6445L69.6357 49.4832L64.6018 46.9671L57.89 49.4832L54.534 42.7736L46.9832 46.9671V23.4832C46.9832 22.8123 41.39 22.6445 38.5933 22.6445Z"
          fill="black"
          stroke="black"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_170_96"
          x="-4"
          y="0"
          width="107"
          height="112"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_170_96"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_170_96"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_170_96"
          x="20.0723"
          y="5.75781"
          width="44.1738"
          height="25.0801"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_170_96"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_170_96"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_170_96"
          x="11.8721"
          y="16.6621"
          width="74.1875"
          height="76.8711"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_170_96"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_170_96"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default Tap
